import React from 'react';
import Field from '../../Field';
import css from './SectionOlena.module.css';

const SectionOlena = props => {
  const { section, options } = props;
  const profileImgUrl = section?.appearance?.backgroundImage?.attributes?.variants?.scaled800?.url;

  return (
    <section id="olena" className={css.root}>
      <div className={css.card}>
        <div className={css.photo}>
          {profileImgUrl ? <img src={profileImgUrl} alt="Olena Dobczansky" /> : null}
        </div>

        <div className={css.info}>
          <p className={css.role}>Co-Founder &amp; Clinical Advisor</p>
          <div className={css.name}>
            <em>Olena</em> Dobczansky
          </div>
          <div className={css.credentials}>MSN, RNC-MNN, IBCLC, C-ONQS, LCCE</div>
          <p className={css.description}>
            A personalized consultation with PostPartners&apos; Clinical Co-Founder, for families
            seeking evidence-informed support through pregnancy and postpartum. Covering birth,
            feeding, recovery, emotional adjustment, and more.
          </p>
        </div>

        <div className={css.cta}>
          <div className={css.durations}>
            <span>15 min</span>
            <span>30 min</span>
            <span>60 min</span>
          </div>
          <span className={css.virtual}>Virtual</span>
          <Field data={section?.callToAction} className={css.button} options={options} />
        </div>
      </div>
    </section>
  );
};

export default SectionOlena;
